<template>
  <div class="admin-pages">
    <PageTitle
      imagem="cadastrarusuarios.png"
      :main="$t('gestao-de-usuarios-0')"
      :sub="$t('insercao-e-ou-alteracoes')"
    />
    <div class="-pagesadmin-tabs">
      <UserAdmin />
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import UserAdmin from "./UserAdmin";

export default {
  name: "AdminPages",
  components: { PageTitle, UserAdmin },
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
